module.exports = __webpack_public_path__ + "img/lionorg.7d6618c2.jpeg";